import computeClassName from '../../../../../utils/computeClassName';
import { useL18nContext } from '../../../ContextProvider/L18n';

const constants = Object.freeze({
  CLASSNAME_BASE: 'font-normal text-cc-body-medium sm:text-cc-body-small'
});
export default function LanguageLabel({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { currentLocale } = useL18nContext();
  const reformattedLocale = currentLocale.toUpperCase().replace('-',' ');
  return <span className={computedClassName}>{reformattedLocale}</span>;
}
